//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'vuex-pathify';

export default {
  name: 'HoldBillDialog',
  props: ["show_status"],
  data () {
    return {
      number: "",
      loading: false,
      total_record: 0,
      total_page: 1,
      total_page_suffix: "",
      rowsPerFetch: 100,
      pagination: {
        rowsPerPage: 0
      },
      pageID: 1,
      findWord: '',
      current_row: 1,
      datalist: [],
      selected: [],
     
      columns: [
        { name: 'rownum', align: 'center', label: 'ลำดับ', field: 'rownum'},
        { name: 'number', align: 'center', label: 'เลขที่เอกสาร', field: 'number'},
        { name: 'date', align: 'center', label: 'วันที่', field: 'date'},
      ],
      /* 
      customDialogModel: false,
      name: ''
      */
      fixed: false,
    }
  },
  methods: {
    clearFilter: function()  {
        this.number = '';
        this.fetchDataList();
    },
    previous_page: function() {
      if (parseInt(this.pageID) > 1) {
        this.pageID = parseInt(this.pageID) - 1;
      }
    },
    next_page: function() {
      if (parseInt(this.pageID) < parseInt(this.total_page)) {
        this.pageID = parseInt(this.pageID) + 1;
      }
    },
    requestRowClick: function(selected_row) {
      //console.log("row click :" + selected_row.rownum);
      this.$emit("onSeleted", selected_row);
      this.fixed = false;
    },
    fetchDataList: function () {
      let self = this;
      self.loading = true;
      const params = new URLSearchParams();
      params.append('pageSize', self.rowsPerFetch);
      params.append('pageID', self.pageID);
      params.append('number', self.number);
      //console.log("fetch bill hold list");
      self.axios({
        method: 'post',
        headers: {
          'Authorization': self.jwt_token
        },
        timeout: 0, // Let's say you want to wait at least 4 mins
        url: self.url_api + 'MemberClient/GetBillHoldAmountHistory.JSON.aspx',
        data: params
      })
      .then(function (response) {
        let responseDoc = new DOMParser().parseFromString(response.data, 'text/xml');
        self.datalist = JSON.parse(responseDoc.getElementsByTagName('json')[0].textContent);
        self.total_record = responseDoc.getElementsByTagName('recordcount')[0].textContent;
        self.total_page = parseInt(responseDoc.getElementsByTagName('pagecount')[0].textContent);
        self.total_page_suffix = "/" + self.total_page;
        setTimeout( function() { 
                    self.loading = false;
                }, 1000);
      })
      .catch(function (error) {
          console.log("Error :" + error);
          setTimeout( function() { 
                    self.loading = false;
                }, 1000);
      });
    }, 
    onShow() {
      console.log("Hold Bill Dialog show");
      //alert("onShow");
      //this.fetchDataList();
    },
    onHide() {
      //console.log("onHide");
      this.$emit("onHide", "");
      //this.$parent.scode_dialog_show = false;
    }
    /*
    ,
    // when props.ok() gets called
    onOk (data) { },

    // when props.cancel() gets called
    onCancel () { },

    // when we show it to the user
    onShow () { },

    // when it gets hidden
    onHide () { },

    // custom handler
    async choose (okFn, hero) {
      if (this.name.length === 0) {
        this.$q.dialog({
          title: 'Please specify your name!',
          message: `Can't buy tickets without knowing your name.`
        })
      }
      else {
        await okFn()
        this.$q.notify(`Ok ${this.name}, going with ${hero}`)
      }
    }
    */
  },
  mounted () {
      //alert("mount HoldBillDialog");
      //console.log('Center Dialog mounted.');
      //this.fetchDataList();
  },
  watch: {
    show_status: function () {
      //console.log("fixed :" + this.fixed);
      this.fixed = this.show_status;
      /*
      if (this.show_status) {
        this.selected.splice(0,1);
      }
      */
    },
    pageID: function () {
      this.fetchDataList();
    }
  },
  computed: {
      url_api: get('URL_API_PATH'),
      jwt_token: get('JWT_TOKEN'),
      session_mcode: get('SESSION_MCODE_LOGIN'),
  }
 
}
